<div id="stacked-area-chartdiv" style="width: 100%; height: 500px"></div>